import fetchAndCheckStatus from '../../edlio-js/utils/fetchAndCheckStatus';

/**
 *
 * @param {Blob} imageFile such as from file input change evt.target
 */
export default async function uploadImage(imageFile) {
  const url = '/apps/api/images/upload';

  const expectedStatuses = [ 200 ];

  const formData = new FormData();
  formData.append('file', imageFile);

  const postOptions = {
    method: 'POST',
    credentials: 'include',
    body: formData
  };

  return await fetchAndCheckStatus(url, expectedStatuses, postOptions);
}



// WEBPACK FOOTER //
// ./src/main/webapps/common/edlio-api/images/uploadImage.js